import _ from "lodash";

const shipmentCreateFormatter = (
  data,
  defaultFormData,
  shipmentFormData,
  reviewFormData
) => {
  const dataSet = data?.data || data;
  const formData = JSON.parse(JSON.stringify(defaultFormData));
  const shipmentData = JSON.parse(JSON.stringify(shipmentFormData));
  const reviewData = JSON.parse(JSON.stringify(reviewFormData));
  const shipmentId = shipmentData["id"];
  const returnData = _.merge(shipmentData, formData, dataSet, reviewData);
  returnData["order_id"] = dataSet["id"];
  returnData["customer_id"] = dataSet["customer_id"].id
  if (shipmentId) {
    returnData["id"] = shipmentId;
  }

  returnData["shipment_status"] = "NEW";
  return returnData;
};

export default shipmentCreateFormatter;
